import actionCreatorFactory from 'typescript-fsa';
import { UserGroupTournamentSubscription } from '../../../services/betting';

const actionCreator = actionCreatorFactory();

export const UGTS_LOAD = 'UGTS_LOAD';
export const ugtsLoad = actionCreator<string>(UGTS_LOAD);

export const UGTS_SET_ENTITIES = 'UGTS_SET_ENTITIES';
export const ugtsSetEntities = actionCreator<UserGroupTournamentSubscription[]>(UGTS_SET_ENTITIES);

export type UgtsSubscription = {
    ugId: string;
    tId: string;
}

export const UGTS_SUBSCRIBE = 'UGTS_SUBSCRIBE';
export const ugtsSubscribe = actionCreator<UgtsSubscription>(UGTS_SUBSCRIBE);

export const UGTS_UNSUBSCRIBE = 'UGTS_UNSUBSCRIBE';
export const ugtsUnubscribe = actionCreator<UgtsSubscription>(UGTS_UNSUBSCRIBE);

